import css from 'styled-jsx/css';

export default css`
  .main-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .section {
    width: 70%;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .title {
    font-size: 32px;
    font-family: 'Eurostile-Bold';
    margin-top: 5%;
    margin-bottom: 1%;
    text-transform: uppercase;
  }
  .description {
    text-align: center;
  }
  .submit {
    display: flex;
    height: 40.4px;
    width: 181px;
    background-color: #950810;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 40px;
    text-align: center;
    border: none;
    color: white;
    border-radius: 3px;
    width: 200px;
    justify-content: center;
    margin-bottom: 5%;
    margin-top: 2%;
  }

  @media (max-width: 600px) {
    .title {
      text-align: center;
      margin-top: 15%;
    }
    .description {
      font-size: 12px;
      line-height: 30px;
      margin-top: 5%;
    }
    .submit {
      margin-bottom: 20%;
    }
  }
`;